export default {
    event_url: '/static/request.php?type=events',
    // event_url: '/static/performances.json',
    news_url: '/static/request.php',
    redirect: false
}




// WEBPACK FOOTER //
// ./src/config.js